module.exports = __webpack_public_path__ + "img/bounding-box.2cd5f866.svg";